import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const COOKIE_KEY = 'COOKIE_KEY';

interface CookieState {
  open: boolean;
  config: Record<string, any>;
}

const initialState: CookieState = {
  open: false,
  config: {}
};

export const cookieSlice = createSlice({
  name: 'cookie',
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setCookieConfig: (state, action: PayloadAction<Record<string, any>>) => {
      state.config = action.payload;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(COOKIE_KEY, 'true');
      }
      state.open = false;
    },
    initializeCookieState: (state) => {
      if (typeof window !== 'undefined') {
        state.open = window.localStorage.getItem(COOKIE_KEY) === null;
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const { setModalOpen, setCookieConfig, initializeCookieState } =
  cookieSlice.actions;

export default cookieSlice.reducer;
